import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { ResponsiveService } from 'src/app/services/responsive/responsive.service';
import { HomeContactsSectionAItem } from './components/home-contacts-section-a-item/home-contacts-section-a-item.component';
import { BaseComponent } from 'src/app/shared/components/base-component';

@Component({
  selector: 'app-home-contacts-section-a',
  templateUrl: './home-contacts-section-a.component.html',
  styleUrls: ['./home-contacts-section-a.component.scss']
})
export class HomeContactsSectionAComponent extends BaseComponent implements OnInit {
  constructor(public override responsive: ResponsiveService, public override transloco: TranslocoService) {
    super(responsive, transloco);
  }

  items: HomeContactsSectionAItem[];

  ngOnInit(): void {
    this.transloco.selectTranslateObject(
      'home.contacts.section_a.items'
    ).subscribe(result => {
      this.items = result;
    });
  }
}
